(() => {
  let refreshSticky = () => {};

  const parseJson = (value, fallback) => {
    try {
      return JSON.parse(value);
    } catch (_error) {
      return fallback;
    }
  };

  const findMainProductForm = () =>
    document.querySelector(
      '.product__info-wrapper form[action*="/cart/add"], product-info form[action*="/cart/add"]'
    );

  const setQuantity = (quantity) => {
    const form = findMainProductForm();
    if (!form) return;

    let input = form.querySelector('input[name="quantity"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      form.appendChild(input);
    }

    input.value = String(quantity);
  };

  const updateOfferImage = (offer) => {
    const secondary = document.querySelector('[data-offer-secondary]');
    const active = secondary?.querySelector('.ct-qty.is-active');
    const quantityIndex = active ? Number(active.dataset.index) : 0;
    const colour = offer.dataset.colour || 'hg';
    const images = parseJson(
      colour === 'an' ? offer.dataset.imagesAn : offer.dataset.imagesHg,
      []
    );
    const image = offer.querySelector('.ct-offer__product img');

    if (image && images[quantityIndex]) {
      image.src = images[quantityIndex];
    }
  };

  const selectQuantity = (offer, button) => {
    const options = parseJson(offer.dataset.options, []);
    const copy = parseJson(offer.dataset.copy, {});
    const option = options[Number(button.dataset.index)];
    if (!option) return;

    const secondary = document.querySelector('[data-offer-secondary]');

    secondary?.querySelectorAll('.ct-qty').forEach((candidate) => {
      const selected = candidate === button;
      candidate.classList.toggle('is-active', selected);
      candidate.setAttribute('aria-pressed', String(selected));
    });

    const quantity = offer.querySelector('[data-offer-quantity]');
    const price = offer.querySelector('[data-offer-price]');
    const compare = offer.querySelector('[data-offer-compare]');
    const sale = offer.querySelector('[data-offer-sale]');
    const caption = offer.querySelector('[data-offer-caption]');
    const checks = secondary?.querySelector('[data-offer-checks]');

    if (quantity) {
      quantity.textContent = `${option.q} ${option.q === 1 ? copy.unit : copy.units}`;
    }
    if (price) price.textContent = option.price;
    if (compare) compare.textContent = option.compare;
    if (sale) sale.textContent = `${option.discount}% ${copy.discount}`;
    if (caption) {
      caption.textContent = `${option.q} ${option.q === 1 ? copy.unit : copy.units}`;
    }

    if (checks) {
      const items =
        option.q === 1
          ? [copy.shipping, copy.trial, copy.warranty]
          : [
              copy.volume.replace('[P]', option.pct),
              copy.shipping,
              copy.trial,
            ];

      checks.replaceChildren(
        ...items.map((label) => {
          const item = document.createElement('li');
          const icon = document.createElement('span');
          icon.className = 'ct-offer__check';
          icon.setAttribute('aria-hidden', 'true');
          icon.textContent = '✓';
          item.append(icon, document.createTextNode(label));
          return item;
        })
      );
    }

    setQuantity(option.q);
    updateOfferImage(offer);
  };

  const setupOffer = () => {
    const offer = document.querySelector('.ct-offer[data-phase1="true"]');
    if (!offer || offer.dataset.ready === 'true') return;
    offer.dataset.ready = 'true';

    const secondary = document.querySelector('[data-offer-secondary]');

    secondary?.addEventListener('click', (event) => {
      const button = event.target.closest('.ct-qty');
      if (button && secondary.contains(button)) {
        selectQuantity(offer, button);
      }
    });

    const form = findMainProductForm();
    const buyBlock = form?.closest('product-form')?.parentElement;
    if (secondary && buyBlock) {
      const paymentBadges = buyBlock.parentElement?.querySelector(
        '.payment-badges-block'
      );
      (paymentBadges || buyBlock).insertAdjacentElement('afterend', secondary);
      secondary.classList.add('ct-offer__secondary--ready');
    }

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (
        !(input instanceof HTMLInputElement) ||
        !input.matches('.product-form__input--pill input[type="radio"]')
      ) {
        return;
      }

      const anthracite = /nthra/i.test(input.value);
      offer.dataset.colour = anthracite ? 'an' : 'hg';

      const colour = offer.querySelector('[data-offer-colour]');
      if (colour) {
        colour.textContent = anthracite
          ? offer.dataset.colourAn
          : offer.dataset.colourHg;
      }

      const image = offer.querySelector('.ct-offer__product img');
      if (image) {
        const colourLabel = anthracite
          ? offer.dataset.colourAn
          : offer.dataset.colourHg;
        image.alt = `${offer.dataset.productTitle}, ${colourLabel}`;
      }

      updateOfferImage(offer);
    });

    setQuantity(1);
    updateOfferImage(offer);
  };

  const setupStickyAddToCart = () => {
    const bar = document.querySelector('.sticky-atc');
    const mainButton = document.querySelector(
      '.product__info-wrapper form[action*="/cart/add"] button[type="submit"]'
    );
    const mainBuyBlock =
      mainButton?.closest('product-form')?.parentElement || mainButton;
    const footer = document.querySelector('footer');
    const introMarker = document.querySelector(
      '.announcement-bar-section .ct-promo-bar, .announcement-bar-section'
    );
    if (!bar || !mainBuyBlock || bar.dataset.phase1Ready === 'true') return;
    bar.dataset.phase1Ready = 'true';

    let hasScrollIntent = !introMarker && window.scrollY > 0;
    let mainButtonVisible = false;
    let footerVisible = false;

    const elementIsVisible = (element) => {
      if (!element || element.hidden) return false;
      const rect = element.getBoundingClientRect();
      return (
        window.getComputedStyle(element).display !== 'none' &&
        window.getComputedStyle(element).visibility !== 'hidden' &&
        rect.height > 0 &&
        rect.bottom > 0 &&
        rect.top < window.innerHeight
      );
    };

    const update = () => {
      const consentVisible = [
        document.querySelector('#shopify-pc__banner'),
        document.querySelector('#shopify-pc__prefs__dialog'),
      ].some(elementIsVisible);
      const visible =
        hasScrollIntent &&
        !mainButtonVisible &&
        !footerVisible &&
        !consentVisible;

      bar.dataset.ctIntent = String(hasScrollIntent);
      bar.dataset.ctMainVisible = String(mainButtonVisible);
      bar.dataset.ctFooterVisible = String(footerVisible);
      bar.dataset.ctConsentVisible = String(consentVisible);
      bar.classList.toggle('ct-phase1-sticky-visible', visible);
      bar.classList.toggle('ct-phase1-sticky-hidden', !visible);
      bar.toggleAttribute('inert', !visible);
      bar.setAttribute('aria-hidden', String(!visible));
    };

    const recomputeGeometry = () => {
      const buyRect = mainBuyBlock.getBoundingClientRect();
      mainButtonVisible =
        buyRect.bottom > 0 && buyRect.top < window.innerHeight;

      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        footerVisible =
          footerRect.bottom > 0 && footerRect.top < window.innerHeight;
      }

      if (introMarker) {
        const markerRect = introMarker.getBoundingClientRect();
        hasScrollIntent = !(
          markerRect.bottom > 0 && markerRect.top < window.innerHeight
        );
      }

      update();
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (introMarker && entry.target === introMarker) {
          hasScrollIntent = !entry.isIntersecting;
        }
        if (entry.target === mainBuyBlock) {
          mainButtonVisible = entry.isIntersecting;
        }
        if (footer && entry.target === footer) {
          footerVisible = entry.isIntersecting;
        }
      });
      update();
    });

    observer.observe(mainBuyBlock);
    if (footer) observer.observe(footer);
    if (introMarker) observer.observe(introMarker);

    let scrollSettleTimer;
    const scheduleSettledCheck = () => {
      window.clearTimeout(scrollSettleTimer);
      scrollSettleTimer = window.setTimeout(recomputeGeometry, 120);
    };

    window.addEventListener('scroll', scheduleSettledCheck, { passive: true });
    window.addEventListener('scrollend', recomputeGeometry, { passive: true });
    window.addEventListener('resize', recomputeGeometry);
    refreshSticky = update;
    recomputeGeometry();
  };

  const setupResponsiveProductHeader = () => {
    const media = document.querySelector('.product__media-wrapper');
    const grid = media?.parentElement;
    const info = document.querySelector('.product__info-wrapper');
    const infoContainer =
      info?.querySelector('.product__info-container') || info;
    const variantPicker = infoContainer?.querySelector('variant-selects');
    const mediaQuery = window.matchMedia('(max-width: 749px)');

    if (!media || !grid || !infoContainer || !variantPicker) return;

    const sync = () => {
      const badge = document.querySelector('.product__info-wrapper .jdgm-widget, #ct-mobile-header .jdgm-widget');
      const badgeBlock =
        badge?.closest('[id^="shopify-block"]') || badge;
      const title = document.querySelector(
        '.product__info-wrapper .product__title, #ct-mobile-header .product__title'
      );
      const subtitle = document.querySelector('#ct-subtitle');

      if (mediaQuery.matches) {
        let header = document.querySelector('#ct-mobile-header');
        if (!header) {
          header = document.createElement('div');
          header.id = 'ct-mobile-header';
          header.style.cssText = 'padding:0 1.5rem;margin-bottom:.6rem;';
          grid.insertBefore(header, media);
        }

        [badgeBlock, title, subtitle].filter(Boolean).forEach((element) => {
          header.appendChild(element);
        });
        return;
      }

      [subtitle, title, badgeBlock].filter(Boolean).forEach((element) => {
        infoContainer.insertBefore(element, infoContainer.firstChild);
      });

      document.querySelector('#ct-mobile-header')?.remove();
    };

    mediaQuery.addEventListener('change', sync);
    window.addEventListener('resize', sync);
    new ResizeObserver(sync).observe(document.documentElement);
    sync();
  };

  const setupCartQuantityKeyboard = () => {
    document.addEventListener(
      'keydown',
      (event) => {
        const input = event.target;
        if (
          event.key !== 'Enter' ||
          !(input instanceof HTMLInputElement) ||
          !input.matches(
            'cart-drawer-items input.quantity__input, #CartDrawer input[name="updates[]"]'
          )
        ) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        input.blur();
      },
      true
    );
  };

  const setupGalleryKeyboard = () => {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const sync = () => {
      gallery.querySelectorAll('.product__media-item').forEach((item) => {
        const opener = item.querySelector('.product__media-toggle');
        if (!opener) return;
        opener.tabIndex = item.classList.contains('is-active') ? 0 : -1;
      });
    };

    const observer = new MutationObserver(sync);
    gallery.querySelectorAll('.product__media-item').forEach((item) => {
      observer.observe(item, {
        attributes: true,
        attributeFilter: ['class'],
      });
    });

    sync();
  };

  const compactConsentBanner = () => {
    const banner = document.querySelector('#shopify-pc__banner');
    if (!banner || banner.dataset.phase1Ready === 'true') return false;
    banner.dataset.phase1Ready = 'true';

    const isGerman = document.documentElement.lang.toLowerCase().startsWith('de');
    const heading = banner.querySelector('h2, h3');
    const body = banner.querySelector('.shopify-pc__banner__body');
    const accept = banner.querySelector('.shopify-pc__banner__btn-accept');
    const decline = banner.querySelector('.shopify-pc__banner__btn-decline');
    const manage = banner.querySelector('.shopify-pc__banner__btn-manage-prefs');

    if (heading) {
      heading.textContent = isGerman ? 'Deine Privatsphäre, deine Wahl' : 'Your privacy, your choice';
    }

    if (body) {
      const link = body.querySelector('a');
      const linkHref = link?.href;
      body.textContent = isGerman
        ? 'Optionale Cookies helfen uns, den Shop zu verbessern und zu verstehen, welche Inhalte hilfreich sind. Du kannst deine Auswahl jederzeit ändern.'
        : 'Optional cookies help us improve the shop and understand which content is helpful. You can change your choice at any time.';

      if (linkHref) {
        body.append(' ');
        const replacement = document.createElement('a');
        replacement.href = linkHref;
        replacement.textContent = isGerman ? 'Mehr erfahren' : 'Learn more';
        body.append(replacement);
      }
    }

    if (accept) {
      accept.textContent = isGerman ? 'Alle akzeptieren' : 'Accept all';
    }
    if (decline) {
      decline.textContent = isGerman ? 'Nur notwendige' : 'Necessary only';
    }
    if (manage) {
      manage.textContent = isGerman ? 'Individuell auswählen' : 'Choose individually';
    }

    [accept, decline, manage].filter(Boolean).forEach((button) => {
      button.addEventListener('click', () => {
        window.setTimeout(refreshSticky, 0);
      });
    });

    refreshSticky();
    return true;
  };

  const start = () => {
    setupOffer();
    setupStickyAddToCart();
    setupResponsiveProductHeader();
    setupCartQuantityKeyboard();
    setupGalleryKeyboard();
    if (compactConsentBanner()) return;

    const observer = new MutationObserver(() => {
      if (compactConsentBanner()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

